import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { NavigationCTX } from './lib/context';

import { initApi } from './lib/api';
import { Routes } from './routes';
import { initAuth } from './lib/cognito';
import { Config } from './types/config';
import { initRealtime } from './lib/realtime';

const auth = initAuth(process.env as Config);

const api = initApi({
  API_URL: process.env.REACT_APP_API_URL,
  FILES_URL: process.env.REACT_APP_FILES_URL,
});

const realtime = initRealtime({
  REALTIME_URL: process.env.REACT_APP_REALTIME_URL,
});

export default function App() {
  const [hideSidebar, setHideSidebar] = useState(true);

  return (
    <NavigationCTX.Provider value={{ hideSidebar, setHideSidebar }}>
      <Router>
        <Routes />
      </Router>
    </NavigationCTX.Provider>
  );
}
